import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  Input,
  Button,
  Label,
  Text,
  Spinner,
} from '@fluentui/react-components';
import { PersonRegular, LockClosedRegular } from '@fluentui/react-icons';
import { useAuth } from '../contexts/AuthContext';
import { validateCredentials } from '../config/demoCredentials';
import { BRANDING } from '../config/branding';
import '../styles/LoginPage.css';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    // Simulate brief loading for UX
    await new Promise((resolve) => setTimeout(resolve, 500));

    const user = validateCredentials(username, password);
    if (user) {
      login({ username: user.username, displayName: user.displayName });
      navigate('/domains');
    } else {
      setError('Invalid username or password');
    }
    setIsLoading(false);
  };

  return (
    <div className="login-container">
      <Card className="login-card">
        <div className="login-header">
          <Text size={700} weight="semibold">{BRANDING.name}</Text>
          <Text size={300} className="login-subtitle">{BRANDING.loginSubtitle}</Text>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-field">
            <Label htmlFor="username">Username</Label>
            <Input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              contentBefore={<PersonRegular />}
              placeholder="Enter username"
              disabled={isLoading}
              required
            />
          </div>

          <div className="login-field">
            <Label htmlFor="password">Password</Label>
            <Input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              contentBefore={<LockClosedRegular />}
              placeholder="Enter password"
              disabled={isLoading}
              required
            />
          </div>

          {error && <Text className="login-error">{error}</Text>}

          <Button
            type="submit"
            appearance="primary"
            className="login-button"
            disabled={isLoading || !username || !password}
          >
            {isLoading ? <Spinner size="tiny" /> : 'Sign In'}
          </Button>
        </form>

        <div className="login-hint">
          <Text size={200}>Powered by Nolij Decision Loop</Text>
          <Text size={200}>Detect · Investigate · Coordinate · Execute · Learn</Text>
        </div>
      </Card>
    </div>
  );
};

export default LoginPage;
